import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { KindService } from 'app/services/models/kind.service';
import { ReminderService } from 'app/services/models/reminder.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-update-reminder-dialog',
  templateUrl: './update-reminder-dialog.component.html',
  styleUrls: ['./update-reminder-dialog.component.scss'],
  encapsulation:ViewEncapsulation.None
})
export class UpdateReminderDialogComponent implements OnInit {
  @Input() data;
  reminderForm: FormGroup;
  kinds: any = [];

  constructor(private activeModal: NgbActiveModal,
    private reminderService: ReminderService,
    private fb: FormBuilder,
    private kindService: KindService,
    private toatrService: ToastrService) { }

  async ngOnInit() {
    this.reminderForm = this.fb.group({
      serviceName: [null, Validators.required],
      kindId: [null, Validators.required],
      isActive: [false],
      message: [null],
      ccMail: [null],
    });
    await this.getAllKinds();
    if (this.data) {
      await this.getByIdReminder(this.data);
    }
  }

  async getByIdReminder(id) {
    const data = await this.reminderService.getByIdReminder(id);
    console.log(data);
    if(data != null){
      this.reminderForm.patchValue({
        serviceName:data.serviceName,
        kindId:data.kindId,
        message:data.message ?? null,
        isActive:data.isActive,
        ccMail:data.ccMail ?? null
      });
    }
  }

  async getAllKinds() {
    const data = await this.kindService.getAllKinds('', 0, 100, 17);
    console.log(data);
    this.kinds = data.types;
  }
  onClose(result: boolean) {
    this.activeModal.close(result);
  }

  async save() {
    if (this.reminderForm.invalid) return;

    try {
      const formValue = this.reminderForm.value;
      const data ={
        id:this.data,
        ...formValue
      }
      console.log(formValue);
      const res = await this.reminderService.updateReminder(data);

      if (res?.status === true) {
        this.toatrService.success(res.message);
        this.activeModal.close(true);
      } else {
        this.toatrService.error(res.message);
      }
    } catch (err) {
      console.error(err);
      this.activeModal.close(false);
    }
  }
}
